import React, { useEffect, useState } from "react";

const Certificates = () => {
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    const fetchCertificates = async () => {
      try {
        const response = await fetch(
          "https://portfolio-dashboard-backend-mu.vercel.app/certificate"
        );
        const data = await response.json();
        setCertificates(data.data);
      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
    };

    fetchCertificates();
  }, []);

  return (
    <div className="px-20 py-12 bg-gradient-to-tr from-teal-900 via-emerald-900 to-stone-900">
      <h2 className="text-xl lg:text-4xl font-semibold mb-12 text-center uppercase text-info">
        Awards & Certifications
      </h2>
      <div
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
        data-aos="fade-up"
        data-aos-duration="3000"
      >
        {certificates?.map((certificate) => (
          <div
            key={certificate._id}
            className="relative bg-teal-900 p-4 rounded overflow-hidden"
            data-aos="zoom-in"
          >
            <img
              src={certificate.img}
              alt={certificate.name}
              className="w-full h-56 object-cover rounded"
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-teal-900 bg-opacity-90 opacity-0 transition-opacity duration-300 hover:opacity-100 text-center p-5">
              <p className="text-center text-white font-semibold mb-2">
                {certificate.name}
              </p>
              <p className="text-sm text-gray-400 mb-2">
                {certificate.institution}
              </p>
              <p className="text-sm text-white">
                <strong>Skills:</strong> {certificate.skills}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificates;
